/* globals jQuery */

import determineTarget from './theme/determine-target';
import toggleElement from './theme/toggle-element';
import setupFocusTrap from './theme/focus-trap';
import setupModals from './theme/modals';
import setupTabs from './theme/tabs';
import setupAccordions from './theme/accordions';
import setupCarousels from './theme/carousels';

jQuery( $ => {
	const $window = $( window );
	const $document = $( document );
	// const $html = $( 'html' );
	const $body = $( 'body' );

	// =========================
	// ! Basic Toggles
	// =========================

	$body.on( 'click', '.js-toggle', function( event ) {
		const target = determineTarget( this );
		if ( target ) {
			event.preventDefault();
			const isOpen = toggleElement( target, null, 'focus' );

			// For global styling that might be needed
			$body.toggleClass( `show-${ target.id }`, isOpen );

			// For additional actions during open/close
			$body.trigger( `toggle:${ target.id }:${ isOpen ? 'on' : 'off' }` );
		}
	} );

	$( '.js-close' ).click( function() {
		toggleElement( this.closest( '[aria-hidden="false"]' ), false );
	} );

	// =========================
	// ! Modals
	// =========================

	// Add classes to modals automatically
	$( '.neihr-modal' ).addClass( 'js-modal' );
	$( '.neihr-modal__close' ).addClass( 'js-modal-close' );
	$( '.neihr-modal__frame' ).addClass( 'js-modal-backdrop' );

	setupModals();

	// =========================
	// ! Tab Set
	// =========================

	// Add classes to tab/tabset blocks automatically
	$( '.neihr-tab-set' ).addClass( 'js-tab-set' );
	$( '.neihr-tab-set__nav-item' ).addClass( 'js-tab' );
	$( '.neihr-tab-panel' ).addClass( 'js-tab-panel' );

	// Mark first tab as auto-open accordion
	$( '.neihr-tab-set' ).each( function() {
		$( this ).find( '.neihr-tab-header__toggle' ).first().addClass( 'auto-open' );
	} );

	setupTabs();

	// =========================
	// ! Accordion
	// =========================

	// Group adjacent accordions
	$( '.neihr-accordion' ).each( function() {
		let $group = $( this ).prev( '.neihr-accordion-group' );
		if ( $group.length === 0 ) {
			$group = $( '<div class="neihr-accordion-group"></div>' );
			$group.insertBefore( this );
		}

		$( this ).appendTo( $group );
	} );

	// Add classes to accordion blocks automatically
	$( '.neihr-accordion-group, .neihr-tab-set' ).addClass( 'js-accordion-group' );
	$( '.neihr-accordion__toggle, .neihr-tab-header__toggle' ).addClass( 'js-accordion-toggle' );
	$( '.neihr-accordion__content, .neihr-tab-panel' ).addClass( 'js-accordion-content' );

	setupAccordions();

	// =========================
	// ! Nav Handling
	// =========================

	// Setup focus trapping on navigation
	$( '[role="navigation"]' ).each( function() {
		// trap focus to items and controlling toggles
		const $items = $( this ).find( 'a, button' ).add( `[aria-controls="${ this.id }"]` );
		$( this ).attr( 'tabindex', -1 );

		setupFocusTrap( this, $items.get(), {
			ignoreCondition: () => this.style.position !== 'fixed',
		} );
	} );

	const $header = $( '.neihr-header' );
	const $navMenu = $( '.navigation .menu' );
	const $navBackdrop = $( '<div class="neihr-header__submenu-backdrop"></div>' );
	$header.append( $navBackdrop );

	// ARIA setup
	$navMenu.find( '.menu-item-has-children' ).each( function( index ) {
		const $toggle = $( this ).children( 'a, button' );
		const $content = $( this ).children( '.sub-menu' );

		const toggleId = `submenu-toggle-${ index }`;
		const contentId = `submenu-content-${ index }`;

		$toggle.attr( {
			id: toggleId,
			'aria-controls': contentId,
			'aria-expanded': false,
		} );
		$content.attr( {
			id: contentId,
			'aria-hidden': true,
		} );
	} );

	// Toggle handling, including backdrop management
	$navMenu.on( 'click', '.menu-item-has-children > [aria-controls]', function( event ) {
		const submenu = determineTarget( this );
		if ( ! submenu.classList.contains( 'sub-menu' ) ) {
			return;
		}

		event.preventDefault();
		submenu.style.setProperty( '--height', submenu.scrollHeight + 'px' );

		const show = this.getAttribute( 'aria-expanded' ) === 'false';
		this.setAttribute( 'aria-expanded', show );
		submenu.setAttribute( 'aria-hidden', ! show );

		if ( show ) {
			$navMenu.find( '.menu-item-has-children > [aria-controls]' ).not( this ).each( function() {
				const target = determineTarget( this );
				if ( target.classList.contains( 'sub-menu' ) ) {
					this.setAttribute( 'aria-expanded', false );
					target.setAttribute( 'aria-hidden', true );
				}
			} );
		}

		// Check if any menus are open
		const hasOpenMenu = $navMenu.find( '[aria-controls][aria-expanded="true"]' ).length > 0;

		let menuHeight = 0;
		if ( hasOpenMenu ) {
			menuHeight = submenu.scrollHeight + 'px';
			// Hide searchbar while submenu is open
			toggleElement( 'searchbar', false );
		}

		// Update/animate submenu backdrop
		$navBackdrop.css( '--height', menuHeight );
		$header.toggleClass( 'has-open-submenu', hasOpenMenu );
	} );

	function closeNavMenus() {
		$( '.sub-menu' ).each( function() {
			toggleElement( this, false );
		} );
		$header.removeClass( 'has-open-submenu' );
	}

	// Close menus when opening searchbar
	$body.on( 'toggle:searchbar:on', closeNavMenus );

	// click outside to close nav
	$( document ).click( function( e ) {
		if ( $( e.target ).parents( '.neihr-header' ).length === 0 ) {
			toggleElement( 'searchbar', false );
			closeNavMenus();
		}
	} );

	// =========================
	// ! Bacgkround color on scroll - Fixed Header
	// =========================
	//https://codepen.io/chris_cook/pen/MJwpPj

	$( function() {
		$window.on( 'scroll', function() {
			if ( $window.scrollTop() > 50 ) {
				$( '.neihr-header' ).addClass( 'active' );
			} else {
				$( '.neihr-header' ).removeClass( 'active' );
			}
		} );
	} );

	// =========================
	// ! Intersection Observers (recycled from lambay)
	// =========================

	if ( typeof IntersectionObserver !== 'undefined' ) {
		// =========================
		// ! - Sticky Header observer
		// =========================

		const $sentinel = $( '.sentinel' );

		const headerObserver = new IntersectionObserver( entries => {
			$header.toggleClass( 'is-sticky', ! entries[ 0 ].isIntersecting );
		} );

		if ( $sentinel.length > 0 ) {
			headerObserver.observe( $sentinel[ 0 ] );
		}

		// =========================
		// ! Highlight Observer
		// =========================

		const highlightObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				if ( change.isIntersecting ) {
					$( change.target ).addClass( 'shown' );
				}
			} );
		} );

		$( '.highlight-wrap' ).each( function() {
			highlightObserver.observe( this );
		} );

		// =========================
		// ! - Page Nav Scroll Spy
		// =========================

		const offsetHeight = $( '.neihr-header' ).outerHeight() || 0;

		const $nav = $( '.js-document-nav' );
		const $navLinks = $nav.find( 'a[href^="#"]' );
		const $navTargets = $navLinks.map( function() {
			return document.querySelector( this.hash );
		} );

		let $lastMatch = null;
		const targetObserver = new IntersectionObserver( changes => {
			changes.forEach( change => {
				$( change.target ).toggleClass( 'in-view', change.isIntersecting );
			} );

			// Find the "current" chunk in view
			let $matches = $navTargets.filter( '.in-view' );

			// In case of multiple, use the first one who's
			// top isn't outside the viewport
			if ( $matches.length > 1 ) {
				$matches = $matches.filter( function() {
					return this.offsetTop >= $window.scrollTop() - offsetHeight;
				} );
			}

			// In case of none, use last chunk
			if ( $matches.length === 0 ) {
				// No fallback, abort
				if ( ! $lastMatch ) {
					return;
				}

				$matches = $lastMatch;
			}

			const $linkMatch = $navLinks.removeClass( 'is-current' )
				.filter( `a[href="#${ $matches.attr( 'id' ) }"]` )
				.addClass( 'is-current' );

			$nav[ 0 ].scrollTo( 0, $linkMatch[ 0 ].offsetTop - offsetHeight );
			$nav.css( '--pagenav-position', $linkMatch.position().top + 'px' );
			$nav.css( '--pagenav-height', $linkMatch.height() + 'px' );

			$lastMatch = $matches;
		}, {
			rootMargin: `${ offsetHeight }px 0px 25%`,
		} );

		$navTargets.each( function() {
			targetObserver.observe( this );
		} );
	}

	// =========================
	// ! Carousels - scrolling system
	// =========================

	setupCarousels( {
		onSlideChange( slide ) {
			slide.scrollIntoView( { block: 'nearest', inline: 'start' } );
		},
	} );

	$( '.neihr-carousel-track' ).scrollLeft( 0 );

	// =========================
	// ! Video embed
	// =========================

	$( '.page-content' ).find( '.play-button' ).click( function( e ) {
		e.preventDefault();

		const url = $( this ).data( 'embed' );

		let $elm;
		if ( url.match( /\.(mp4|m4v)$/ ) ) {
			$elm = $( `<video src="${ url }" autoplay controls></video>` );
		} else {
			$elm = $( `<iframe src="${ url }" frameborder="0" allowfullscreen></iframe>` );
		}

		$elm.insertAfter( this );
		$( this ).hide();
	} );

	// =========================
	// ! Input Placeholder Hack
	// =========================

	$( '.search-bar input' ).focus( function() {
		if ( this.value === '' ) {
			$( this ).val( $( this ).data( 'value' ) );
		}
	} ).on( 'input blur', function() {
		$( this ).attr( 'placeholder', this.value ? `Looking for \u201C${ this.value }\u201D` : 'Search\u2026' );
	} ).blur( function() {
		$( this ).data( 'value', this.value ).val( null );
	} ).trigger( 'blur' );
} );
